import type {FontInfo} from '@remotion/google-fonts';
import React, {useMemo} from 'react';
import type {EditorStarterAsset} from '../components/remotion-editor/assets/assets';
import {MainComposition} from '../components/remotion-editor/canvas/composition';
import {
	type ActiveCanvasSnap,
	ActiveCanvasSnapContext,
	AllItemsContext,
	AssetsContext,
	AssetStatusContext,
	TracksContext,
} from '../components/remotion-editor/context-provider';
import type {EditorStarterItem} from '../components/remotion-editor/items/item-type';
import type {TrackType} from '../components/remotion-editor/state/types';
import {FontInfoContext} from '../components/remotion-editor/utils/text/font-info';

export type CompositionWithContextsProps = {
	tracks: TrackType[];
	items: Record<string, EditorStarterItem>;
	assets: Record<string, EditorStarterAsset>;
	compositionWidth: number;
	compositionHeight: number;
	fontInfos: Record<string, FontInfo>;
};

export const CompositionWithContexts: React.FC<
	CompositionWithContextsProps
> = ({tracks, assets, items, fontInfos}) => {
	const tracksContext = useMemo(
		(): TracksContext => ({
			tracks,
		}),
		[tracks],
	);

	const allItemsContext = useMemo(
		(): AllItemsContext => ({
			items,
		}),
		[items],
	);

	const assetsContext = useMemo(
		(): AssetsContext => ({
			assets,
		}),
		[assets],
	);

	const assetStatusContext = useMemo(
		(): AssetStatusContext => ({
			assetStatus: {},
		}),
		[],
	);

	const activeCanvasSnapContext = useMemo(
		(): ActiveCanvasSnap => ({
			activeCanvasSnapPoints: [],
		}),
		[],
	);

	return (
		<ActiveCanvasSnapContext.Provider value={activeCanvasSnapContext}>
			<FontInfoContext.Provider value={fontInfos}>
				<TracksContext.Provider value={tracksContext}>
					<AllItemsContext.Provider value={allItemsContext}>
						<AssetsContext.Provider value={assetsContext}>
							<AssetStatusContext.Provider value={assetStatusContext}>
								<MainComposition playerRef={null} />
							</AssetStatusContext.Provider>
						</AssetsContext.Provider>
					</AllItemsContext.Provider>
				</TracksContext.Provider>
			</FontInfoContext.Provider>
		</ActiveCanvasSnapContext.Provider>
	);
};
